function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from 'react';
import T from 'prop-types';
import classnames from 'classnames';
var List = function(props) {
    var children = props.children, isBorderless = props.isBorderless, isPaddingless = props.isPaddingless, className = props.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('List', _define_property({
            'is-borderless': isBorderless,
            'is-paddingless': isPaddingless
        }, className, className))
    }, /*#__PURE__*/ React.createElement("table", null, children));
};
var Item = function(param) {
    var description = param.description, value = param.value, isHighlighted = param.isHighlighted, isSecondaryHighlight = param.isSecondaryHighlight, isValueSecondaryHighlight = param.isValueSecondaryHighlight, isColonAppended = param.isColonAppended, className = param.className, _param_midText = param.midText, midText = _param_midText === void 0 ? null : _param_midText;
    var _obj;
    return /*#__PURE__*/ React.createElement("tr", {
        className: classnames(_define_property({
            'is-highlighted': isHighlighted,
            'secondary-highlight': isSecondaryHighlight,
            'secondary-highlight-value': isValueSecondaryHighlight,
            'is-colon-appended': isColonAppended
        }, className, className))
    }, /*#__PURE__*/ React.createElement("td", {
        className: classnames('description', (_obj = {}, _define_property(_obj, className, className), _define_property(_obj, 'width-50', midText), _obj))
    }, description), midText ? /*#__PURE__*/ React.createElement("td", {
        className: "width-30"
    }, midText) : null, /*#__PURE__*/ React.createElement("td", {
        className: classnames('value', _define_property({}, className, className))
    }, value));
};
Item.propTypes = {
    description: T.string,
    value: T.any,
    isHighlighted: T.bool,
    isSecondaryHighlight: T.bool,
    isValueSecondaryHighlight: T.bool,
    isColonAppended: T.bool,
    className: T.string,
    midText: T.node
};
List.Item = Item;
export default List;
